import React, { useState, useEffect } from "react";

// Modules

// App
import { serverUrl } from "../../config";
import { getOnlineNode } from "../../core/getNode";
import { postNode } from "../../core/postNode";
import { deleteRequest } from "../../core/delete";

// Ui
import { IconButton, Typography } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import Like from '@mui/icons-material/ThumbUpOutlined';
import LikeActive from '@mui/icons-material/ThumbUp';
import Heart from '@mui/icons-material/FavoriteBorderOutlined';
import HeartActive from '@mui/icons-material/FavoriteOutlined';
import Happy from '@mui/icons-material/EmojiEmotionsOutlined';
import HappyActive from '@mui/icons-material/EmojiEmotions';

export default function Reactions(props) {
  const [like, setLike] = useState(0);
  const [love, setLove] = useState(0);
  const [laugh, setLaugh] = useState(0);
  const [id, setId] = useState(null);

  const [isLoading, setLoading] = useState(true);
  const [hasReacted, setReacted] = useState(false);
  const [activeReaction, setActiveReaction] = useState(null);

  useEffect(() => {
    getReactions();
  }, []);

  const getReactions = () => {
    if (props.nid) {
      const path = `api/reactions/${props.nid}`;

      getOnlineNode(path, props.user.access_token)
        .then((response) => {
          let likeCount = 0;
          let heartCount = 0;
          let laughCount = 0;

          if (response.data.rows.length > 0) {
            response.data.rows.forEach(reaction => {
              if (reaction.type === 'reaction_like') {
                likeCount++;
              }

              if (reaction.type === 'reaction_love') {
                heartCount++;
              }

              if (reaction.type === 'reaction_laughing') {
                laughCount++;
              }

              if (reaction.user_id === props.user.current_user.uid) {
                setActiveReaction(reaction.type);
                setReacted(true);
                setId(reaction.id);
              }
            });
          }

          setLike(likeCount);
          setLove(heartCount);
          setLaugh(laughCount)
          setLoading(false);
        })
        .catch((error) => {
          console.log('err: ', error);
          setLoading(false);
        });
    }
  };

  const addReaction = (type) => {
    setLoading(true);

    const data = {
      _links: {
        type: {
          href: `${serverUrl}/rest/type/vote/${type}`,
        },
      },
      entity_id: [
        {
          target_id: props.nid,
        },
      ],
      entity_type: [
        {
          value: "node",
        },
      ],
    };

    postNode("entity/vote", data, props.user.csrf_token)
      .then((response) => {
        setReacted(true);
        setId(response.data.id[0].value);
        getReactions();
      })
      .catch((_error) => {
        console.log("@addReaction [comment]: ", _error);
        setLoading(false);
      });
  };

  const removeReaction = () => {
    if (id) {
      setLoading(true);
      deleteRequest(
        "entity/vote/" + id,
        props.user.csrf_token,
        props.user.access_token
      )
        .then((response) => {
          setActiveReaction(null);
          setReacted(false);
          setId(null);
          getReactions();
        })
        .catch((_error) => {
          console.log("@_error: ", _error);
          setLoading(false);
        });
    }
  };

  return (
    <Row className="reactions-container gx-0 d-flex justify-content-center align-items-center">
      <Col xs={"auto"} className="reaction">
        <Row className="d-flex align-items-center gx-0">
          <Col xs={"auto"}>
            <IconButton
              className="reaction-btn like"
              disabled={(isLoading || (hasReacted && activeReaction !== "reaction_like"))}
              onClick={() => {
                if (hasReacted) {
                  removeReaction();
                } else {
                  addReaction('reaction_like');
                }
              }}
            >
              {activeReaction === "reaction_like" ? <LikeActive color="commentLike" /> : <Like color="commentLike" />}
            </IconButton>
          </Col>
          <Col xs={"auto"}>
            <Typography className="reaction-count">{like}</Typography>
          </Col>
        </Row>
      </Col>
      <Col xs={"auto"} className="reaction">
        <Row className="d-flex align-items-center gx-0">
          <Col xs={"auto"}>
            <IconButton
              className="reaction-btn heart"
              disabled={(isLoading || (hasReacted && activeReaction !== "reaction_love"))}
              onClick={() => {
                if (hasReacted) {
                  removeReaction();
                } else {
                  addReaction('reaction_love');
                }
              }}
            >
              {activeReaction === "reaction_love" ? <HeartActive color="commentLove" /> : <Heart color="commentLove" />}
            </IconButton>
          </Col>
          <Col xs={"auto"}>
            <Typography className="reaction-count">{love}</Typography>
          </Col>
        </Row>
      </Col>
      <Col xs={"auto"} className="reaction">
        <Row className="d-flex align-items-center gx-0">
          <Col xs={"auto"}>
            <IconButton
              className="reaction-btn happy"
              disabled={(isLoading || (hasReacted && activeReaction !== "reaction_laughing"))}
              onClick={() => {
                if (hasReacted) {
                  removeReaction();
                } else {
                  addReaction('reaction_laughing');
                }
              }}
            >
              {activeReaction === "reaction_laughing" ? <HappyActive color="commentLaugh" /> : <Happy color="commentLaugh" />}
            </IconButton>
          </Col>
          <Col xs={"auto"}>
            <Typography className="reaction-count">{laugh}</Typography>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}